import { render, staticRenderFns } from "./Pog.vue?vue&type=template&id=3c4bc6ba&scoped=true&"
import script from "./Pog.vue?vue&type=script&lang=js&"
export * from "./Pog.vue?vue&type=script&lang=js&"
import style0 from "./Pog.vue?vue&type=style&index=0&id=3c4bc6ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bc6ba",
  null
  
)

export default component.exports